import { useState } from "react";

import { Box, CircularProgress } from "@mui/material";

import { TCourseDocument } from "../../../../@types";

export type TCourseDocumentImageProps = {
	file: TCourseDocument;
};

export function CourseDocumentImage({ file }: TCourseDocumentImageProps) {
	const [isLoading, setIsLoading] = useState(true);

	const onLoad = () => {
		setIsLoading(false);
	};

	return (
		<div className="media-container">
			<img src={file.url} alt={file.name} className="media" onLoad={onLoad} />
			{isLoading && (
				<Box sx={{ position: "absolute", display: "inline-flex" }}>
					<CircularProgress />
				</Box>
			)}
		</div>
	);
}
